"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import Api from "../../api/api";
export class LoadShipment {
  constructor(loadShipment) {
    __publicField(this, "loadShipment");
    this.loadShipment = loadShipment;
  }
  isApproved() {
    return this.loadShipment.state === "Approved";
  }
  unapprovingAllowed() {
    const settings = Api.Account.currentSettings() || {};
    const blockedStatuses = settings["shipment_block_unapprove_statuses_for_billing"] || [];
    return !blockedStatuses.includes(this.loadShipment.shipment_status);
  }
}
